const CET_ZONE = 'Europe/Berlin';

function formatCetTime(value) {
    if (!value) return '—';
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '—';
    return date.toLocaleString('en-GB', {
        timeZone: CET_ZONE,
        hour: 'numeric',
        minute: '2-digit',
        hourCycle: 'h12',
    });
}

function formatDurationMs(ms) {
    if (typeof ms !== 'number' || ms <= 0) return '—';
    const minutes = Math.round(ms / 60000);
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours && mins) return `${hours}h ${mins}m`;
    if (hours) return `${hours}h`;
    return `${mins}m`;
}

export default function OperatorBreaks({ operators }) {
    const people = operators || [];
    if (!people.length) return null;
    return (
        <div style={{ marginTop: 8, fontSize: 13, lineHeight: 1.6 }}>
            <div style={{ fontSize: 12, color: '#667085', marginBottom: 4 }}>Breaks · gaps over 20 minutes and under 3 hours</div>
            {people.map(person => (
                <div key={person.name} style={{ marginBottom: 6 }}>
                    <div>
                        {person.name} · {person.count || 0} {person.count === 1 ? 'break' : 'breaks'}
                        {person.totalMs ? ` · ${formatDurationMs(person.totalMs)}` : ''}
                    </div>
                    {(person.breaks || []).map(item => (
                        <div key={`${person.name}-${item.start}`} style={{ color: '#344054' }}>
                            {formatCetTime(item.start)} – {formatCetTime(item.end)} · {formatDurationMs(item.ms)} CET
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
}
